// extracted by mini-css-extract-plugin
export var active = "_li-2";
export var recordingDot = "_li-1";
export var recordingIndicator = "_li-0";